import { pipe, map, prop } from "ramda";

export const createSetFromListId = pipe(map<{ id: number }, number>(prop("id")), list => new Set(list));
